import _actions_re_list from './_actions/re_list.js'
import _actions_get_list from './_actions/get_list.js'
import _getters_getById from './_getters/getById.js'
import _mutations_add from './_mutations/add.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    mutations:{
        add: _mutations_add,
    },
    getters:{
        getById: _getters_getById,
    },
    actions:{
        get_list: _actions_get_list,
        re_list: _actions_re_list,
    },
}